module.exports = __webpack_public_path__ + "media/images/lp/lp25-a13bb1d54a92425eae1ff3ea049ee764.webp";